export const scrollToTop = () => {
	return window.scrollTo(0, 0);
};